import type {ResourceConfig} from '@github-ui/custom-properties-types'

type ResourceType = 'OIDCCustomPropertyInclusion'

export const RESOURCE_CONFIG = {
  OIDCCustomPropertyInclusion: {
    displayName: 'Actions OIDC Configurations',
    resourcePath: urlPrefix => `/${urlPrefix}/settings/actions/oidc-configuration`,
  },
} as const satisfies Record<ResourceType, ResourceConfig>
